export default __webpack_public_path__ + "static/media/expenseIcon.afd31b31.svg";